<template>
  <v-layout column class="inner-pages">

    <Header :header-height="$auth.check() ? '70px': '120px'" />

    <v-flex px-5 pt-5 class="sfh-login-form background-image center-pb-10">
      <v-layout align-center justify-center>
        <v-flex :class="$store.getters.getIPad ? 'md4': ''">
          <div class="pt-5 pb-5">
        <input type="password" style="display:none" tabindex="-1"/>

        <v-text-field
          type="text"
          :autofocus=true
          v-validate="'required|emailOrPretend'"
          :error-messages="errors.collect('slot1.username')"
          v-model="username"
          label="Username or Email"
          data-vv-name="slot1.username"
          data-vv-scope="slot1"
        ></v-text-field>

        <v-text-field
          :append-icon="e1 ? 'visibility' : 'visibility_off'"
          @click:append="() => (e1 = !e1)"
          :type="e1 ? 'password' : 'text'"
          v-validate="'required'"
          :error-messages="errors.collect('slot1.password')"
          v-model="password"
          label=Password
          id="passwordId"
          data-vv-name="slot1.password"
          ref="passwordRef"
          class="notranslate"
          data-vv-scope="slot1"
          :onautocomplete=false
          @keyup.native.enter="login"
        ></v-text-field>

        <v-checkbox
          class="mt-0"
          color="primary"
          v-model="rememberMe"
          label="Remember me"
        ></v-checkbox>

        <v-btn
          block
          class="btn--block btn--flat btn--large mt-0"
          :loading="loading"
          color="primary"
          @click.prevent="login">
          Sign in
        </v-btn>

        <v-flex style="display: flex;justify-content: space-between;">
          <router-link
            class="caption mt-0 grey--text text--darken-2"
            tag="a"
            :to="{ name: 'ForgotPassword' }">
            Forgot password
          </router-link>
          <span style="text-decoration: underline;font-size: 12px">
            <Translate />
          </span>
        </v-flex>

        <v-flex
          grey--text
          text--darken-2
          v-if="enabledSignUp"
          class="mt-2">
            I don't have an account
          <v-btn
            block
            class="btn--block btn--flat btn--large mt-0"
            color="success"
            @click.prevent="gotoSignUp">
            Sign Up
          </v-btn>
        </v-flex>
        <v-flex class="pt-5" v-if="showAnabIcon">
          <v-img
            style="opacity: 0.3; background-position: center; margin: 0 auto"
            width="200"
            :src="anabIcon"
            alt="anab" title="ANAB"/>
        </v-flex>
      </div>
        </v-flex>
      </v-layout>
    </v-flex>

  </v-layout>
</template>

<script>
  import Vue from 'vue'
  import VeeValidate, {Validator} from 'vee-validate'
  import Header from '../../layouts/Header'
  import {mapMutations} from 'vuex'
  import Translate from '../../Translate.vue'
  // import { Keyboard } from '@capacitor/keyboard'
  // import {Capacitor} from '@capacitor/core'

  Vue.use(VeeValidate)

  const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  const PRETEND_SEPARATOR = '{{as}}'

  Validator.extend('emailOrPretend', {
    getMessage: () => 'Enter a valid email, or use "email{{as}}email" to pretend as another user',
    validate: (value) => {
      if (!value) return false
      if (value.indexOf(PRETEND_SEPARATOR) !== -1) {
        const parts = value.split(PRETEND_SEPARATOR)
        if (parts.length !== 2) return false
        const [admin, target] = parts.map(p => p.trim())
        return EMAIL_REGEX.test(admin) && EMAIL_REGEX.test(target)
      }
      return EMAIL_REGEX.test(value.trim())
    }
  })
  export default {
    name: 'Login',
    components: {Translate, Header},
    data: () => ({
      enabledSignUp: process.env.SIGNUP,
      anabIcon: require('@/assets/logos/ANAB-Symbol-Black.png'),
      loading: false,
      showAnabIcon: true,
      username: '',
      password: '',
      rememberMe: false,
      apiUrl: process.env.API_URL,
      siteUrl: process.env.SITE_URL,
      loginErrorMsg: '',
      e1: true,
      dictionary: {
        custom: {
          'slot1.username': {
            required: () => 'Username or Email is required',
            emailOrPretend: () => 'Enter a valid email'
          },
          'slot1.password': {
            required: () => 'Password is required'
          }
        }
      }
    }),
    created () {
      setTimeout(() => {
        if (this.$auth.token()) {
          this.$auth.watch.authenticated = true
          // this.$router.push({name: 'Programs'})
        }
        this.$store.commit('setIsCompactHeader', true)
      }, 500)
      /* Resetting user */
      this.resetUser()
      this.$store.commit('course/setMemberCurrentLevel', 0)
      // if (Capacitor.isNativePlatform()) {
      //   Keyboard.addListener('keyboardWillShow', () => {
      //     console.log('keyboard will show:')
      //     // Keyboard.setScroll({isDisabled: true})
      //     // this.showAnabIcon = false
      //   })
      //
      //   Keyboard.addListener('keyboardWillHide', () => {
      //     console.log('keyboard will show:')
      //     // Keyboard.setScroll({isDisabled: false})
      //     this.showAnabIcon = true
      //   })
      // }
      // Keyboard.addListener('keyboardDidShow', info => {
      //   console.log('keyboard did show with height:', info.keyboardHeight)
      //   Keyboard.setScroll({ isDisabled: true })
      // })
    },
    mounted () {
      this.$validator.localize('en', this.dictionary)
      const rememberMe = localStorage.getItem('login_remember_me')
      if (rememberMe === 'yes') {
        this.rememberMe = rememberMe
        this.username = localStorage.getItem('login_user_name')
        this.password = localStorage.getItem('login_password')
      }
      this.getAppDetails()
    },
    methods: {
      ...mapMutations('registration', [
        'resetUser'
      ]),
      gotoSignUp () {
        this.$router.push({name: 'SignUp', params: {step: 'confirm-my-email'}})
      },
      jsonToQueryString (json) {
        return '' +
          Object.keys(json).map(function (key) {
            return encodeURIComponent(key) + '=' +
              encodeURIComponent(json[key])
          }).join('&')
      },
      isSfh () {
        return [52, 68].includes(+process.env.GAME_ID)
      },
      me () {
        let username = this.username
        if (username.includes('{{as}}')) {
          const parts = username.split('{{as}}')
          if (parts.length === 2) {
            username = parts[1].trim()
          }
        }
        const router = this.$router
        const url = this.isSfh() ? `${this.apiUrl}/ws/playerservice/user/${username}` : `${this.apiUrl}/ws/playerservice/user/${username}?deck=${process.env.GAME_ID}`
        this.$http({
          url,
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + this.$auth.token()
          }
        }).then((res) => {
          this.$auth.user(res.data)
          this.$auth.watch.authenticated = true

          document.cookie = 'user_name=' + res.data.friendlyName + ';domain=cogneti.com'
          document.cookie = 'user_email=' + res.data.email + ';domain=cogneti.com'
          localStorage.setItem('user_name', res.data.friendlyName)
          const countryId = res.data.countryId !== null ? res.data.countryId : 233

          this.$store.commit('user/setCountry', countryId)
          this.$store.commit('user/setUserDetails', res.data)
          this.$store.commit('user/setAvatar', res.data.userImageUrl)
          this.$store.commit('user/setFirstName', res.data.firstName)
          this.$store.commit('user/setLastName', res.data.lastName)
          this.$store.commit('user/setUserId', res.data.id)
          this.$store.commit('user/setState', res.data.stateId)
          this.$store.commit('user/setPhone', res.data.phoneNumber)
          this.$store.commit('user/setAddressLine1', res.data.addressLine1)
          this.$store.commit('user/setAddressLine2', res.data.addressLine2)
          this.$store.commit('user/setCity', res.data.city)
          this.$store.commit('user/setCourses', res.data.courses)
          this.$store.commit('user/setPostalCode', res.data.postalCode)
          const keyEmail = localStorage.getItem('email')
          if (typeof keyEmail === 'undefined' || keyEmail !== res.data.email) {
            localStorage.setItem('email', res.data.email)
            this.$store.commit('setDashboardTourStart', 0)
            this.$store.commit('setNewUserLoggedin', true)
            this.$store.commit('setTourStatus', true)
            this.$store.commit('setLearnStatus', true)
            this.$store.commit('setQuizStatus', true)
            this.$store.commit('course/setLastPlayedLevel', 0)
            this.$store.commit('course/setLevels', [])
            this.$store.commit('course/setGroups', [])
            this.$store.commit('course/setMemberId', 0)
            // this.$store.commit('course/setExamStatus', -1)
            this.$store.commit('course/setBadgeScore', -1)
            this.$store.commit('course/setCourseLevelLoadedAfterLogin', false)
          } else {
            this.$store.commit('setNewUserLoggedin', false)
          }
        }).then(() => {
          this.$http({
            url: `${this.apiUrl}/ws/compliance/programs/course/${process.env.GAME_ID} `,
            method: 'GET',
            headers: {
              Authorization: 'Bearer ' + this.$auth.token()
            }
          }).then((res) => {
            this.$store.commit('complianceProgram/setPrograms', res.data)
            // this.$router.push({name: 'Programs'}).catch(() => {})
          })
        }).catch(function (error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(1, error.response.data)
            console.log(2, error.response.status)
            console.log(3, error.response.headers)
            if (error.response.data === 'user profile for the deck not found') {
              // eslint-disable-next-line no-console
              console.log('IN IF user profile for the deck not found')
              localStorage.setItem('email', username)
              router.push({name: 'Register', params: {step: 'confirm-my-phone'}})
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(4, error.request)
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error 5', error.message)
          }
          console.log(6, error.config)
        })
      },
      getAppDetails () {
        // eslint-disable-next-line no-console
        console.log('Getting APP')
        this.$http({
          url: `${this.apiUrl}/ws/userservice/apps/${process.env.GAME_ID} `,
          method: 'GET'
        }).then((res) => {
          console.log('res', res.data.version)
          const version = res.data.version.toString()
          if (localStorage.getItem('version') !== version) {
            localStorage.clear()
            localStorage.setItem('version', version)
            window.location.reload(true)
          }
        })
      },
      login () {
        this.loginErrorMsg = ''
        this.$validator.validateAll('slot1').then((result) => {
          if (result) {
            this.loading = true
            let parameters = {
              grant_type: 'password',
              client_id: process.env.CLIENT_ID,
              client_secret: process.env.CLIENT_SECRET,
              username: this.username.trim(),
              password: this.password.trim()
            }
            this.loginLoader = true
            this.$auth.login({
              headers: {
              },
              data: this.jsonToQueryString(parameters),
              rememberMe: this.rememberMe,
              success (res) {
                this.loginLoader = false
                this.$store.commit('setAuthToken', this.$auth.token())
                document.cookie = 'auth_token=' + this.$auth.token() + ';domain=cogneti.com'
                this.$store.commit('user/resetUser', '')
                if (this.rememberMe) {
                  localStorage.setItem('login_user_name', this.username)
                  localStorage.setItem('login_password', this.password)
                  localStorage.setItem('login_remember_me', 'yes')
                } else {
                  localStorage.setItem('login_user_name', '')
                  localStorage.setItem('login_password', '')
                  localStorage.setItem('login_remember_me', 'no')
                }
                this.me()
              },
              error (err) {
                console.log('Error Occur:' + err)
                this.errors.add({
                  scope: 'slot1',
                  field: 'password',
                  msg: 'Invalid username or password'
                })
                this.loading = false
                this.loginLoader = false
              }
            })
          } else {
            this.loading = false
          }
        })
      }
    }
  }
</script>

<style scoped>
  .sfh-login-form {
    display: flex;
    flex-direction: inherit;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/auth/Login.vue